import { render } from "./QuantityIncreaser.vue?vue&type=template&id=5b1496d8&scoped=true&ts=true"
import script from "./QuantityIncreaser.vue?vue&type=script&lang=ts"
export * from "./QuantityIncreaser.vue?vue&type=script&lang=ts"

import "./QuantityIncreaser.vue?vue&type=style&index=0&id=5b1496d8&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1496d8"]])

export default __exports__